import { render } from "./np-bank-validate.vue?vue&type=template&id=fd5b039a"
import script from "./np-bank-validate.vue?vue&type=script&lang=js"
export * from "./np-bank-validate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__